<template>
  <div>
    <div class="localdiv tright pr15 tc6 pt35 pb15" v-if="list.length>0">
      <span class="fs24 fl tc3 lborder prelative pl25 lh10">{{$params['column'][pid]['children'][id]['name']}}</span>
      <div class="pt10">
        当前位置:
        <router-link to="/">学校首页 > </router-link>
        <span>{{$params['column'][pid]['name']}} > </span>
        <router-link :to="{path:'/evn/list',query:{pid:pid,id:id}}">{{$params['column'][pid]['children'][id]['name']}}</router-link>
      </div>
    </div>
    <div class="cont tleft pt55">
      <div class="sxnews tleft prelative cpointer dinline-block trans3" @click="goContent(item.id,index)" v-for="(item,index) in list" :key="item.id">
        <div class="date pabsolute twhite bg-red tcenter lh12 pt5">
          <div class="fs24">{{item.created_at | dateToTime | timeToDate('d')}}</div>
          <div>{{item.created_at | dateToTime | timeToDate('Y-m')}}</div>
        </div>
        <div class="igs ofhidden">
          <img class="trans3" :src="item.content|getImg" alt="" width="306" height="205">
        </div>
        <div class="txt">
          <div class="nm fs18 lh17 ofhidden">{{item.title}}</div>
          <div class="zbtn ml10 mt20 border-80 tc6 br5">详细内容</div>
        </div>
      </div>
    </div>
    <!---->
    <pagec :page="page" :total="total" :size="perPage" @get-data="getData" :key="id+pid"/>
  </div>
</template>

<script>
import Pagec from "./Page";

export default {
  name: "ListXnews",
  data(){
    return {
    }
  },
  props:[
    'id',
    'pid',
    'list',
    'total',
    'page',
    'perPage',
    'getData',
  ],
  filters:{
    getImg(html){
      var arr = html.match(/src="http(.*?)"/i)
      if(arr && arr[1]){
        return 'http'+arr[1];
      }
      var arr = html.match(/src="data:(.*?)"/i)
      if(arr && arr[1]){
        return 'data:'+arr[1];
      }
      return require('@/assets/images/noimg.jpg')

    },
    dateToTime(date){
      date = date.replace(/-/g,'/');
      var time = new Date(date);
      time = time.getTime()
      return time/1000;
    },
    timeToDate (timestamp,format) {
      var a, jsdate=((timestamp) ? new Date(timestamp*1000) : new Date());
      var pad = function(n, c){
        if((n = n + "").length < c){
          return new Array(++c - n.length).join("0") + n;
        } else {
          return n;
        }
      };
      var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
      var txt_ordin = {1:"st", 2:"nd", 3:"rd", 21:"st", 22:"nd", 23:"rd", 31:"st"};
      var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
      var f = {
        // Day
        d: function(){return pad(f.j(), 2)},
        D: function(){return f.l().substr(0,3)},
        j: function(){return jsdate.getDate()},
        l: function(){return txt_weekdays[f.w()]},
        N: function(){return f.w() + 1},
        S: function(){return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'},
        w: function(){return jsdate.getDay()},
        z: function(){return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0},

        // Week
        W: function(){
          var a = f.z(), b = 364 + f.L() - a;
          var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
          if(b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b){
            return 1;
          } else{
            if(a <= 2 && nd >= 4 && a >= (6 - nd)){
              nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
              return date("W", Math.round(nd2.getTime()/1000));
            } else{
              return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
            }
          }
        },

        // Month
        F: function(){return txt_months[f.n()]},
        m: function(){return pad(f.n(), 2)},
        M: function(){return f.F().substr(0,3)},
        n: function(){return jsdate.getMonth() + 1},
        t: function(){
          var n;
          if( (n = jsdate.getMonth() + 1) == 2 ){
            return 28 + f.L();
          } else{
            if( n & 1 && n < 8 || !(n & 1) && n > 7 ){
              return 31;
            } else{
              return 30;
            }
          }
        },

        // Year
        L: function(){var y = f.Y();return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0},
        //o not supported yet
        Y: function(){return jsdate.getFullYear()},
        y: function(){return (jsdate.getFullYear() + "").slice(2)},

        // Time
        a: function(){return jsdate.getHours() > 11 ? "pm" : "am"},
        A: function(){return f.a().toUpperCase()},
        B: function(){
          // peter paul koch:
          var off = (jsdate.getTimezoneOffset() + 60)*60;
          var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
          var beat = Math.floor(theSeconds/86.4);
          if (beat > 1000) beat -= 1000;
          if (beat < 0) beat += 1000;
          if ((String(beat)).length == 1) beat = "00"+beat;
          if ((String(beat)).length == 2) beat = "0"+beat;
          return beat;
        },
        g: function(){return jsdate.getHours() % 12 || 12},
        G: function(){return jsdate.getHours()},
        h: function(){return pad(f.g(), 2)},
        H: function(){return pad(jsdate.getHours(), 2)},
        i: function(){return pad(jsdate.getMinutes(), 2)},
        s: function(){return pad(jsdate.getSeconds(), 2)},
        //u not supported yet

        // Timezone
        //e not supported yet
        //I not supported yet
        O: function(){
          var t = pad(Math.abs(jsdate.getTimezoneOffset()/60*100), 4);
          if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
          return t;
        },
        P: function(){var O = f.O();return (O.substr(0, 3) + ":" + O.substr(3, 2))},
        //T not supported yet
        //Z not supported yet

        // Full Date/Time
        c: function(){return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()},
        //r not supported yet
        U: function(){return Math.round(jsdate.getTime()/1000)}
      };

      return format.replace(/[]?([a-zA-Z])/g, function(t, s){
        if( t!=s ){
          // escaped
          return s;
        } else if( f[s] ){
          // a date function exists
          return f[s]();
        } else{
          // nothing special
          return s;
        }
      });
    }
  },
  destroyed() {
    this.$emit('clear-list');
  },
  created() {
  },
  mounted() {

  },
  updated() {
  },
  components:{
    Pagec
  },
  methods:{
    goContent(id,index){
      var routeQuery = this.$route.query;
      var query = {
        article_id:id,
        num:(this.page - 1) * this.perPage + index + 1,
        pid:routeQuery.pid,
        id:routeQuery.id,
      }
      this.$router.push({path:'/evn/detail',query:query})
    },
  },
  watch:{
    list:{
      deep:true,
      immediate:true,
      handler:function(n,o){

      }
    }
  }
}
</script>

<style scoped>
  /* news **/
  .sxnews:nth-child(3n){margin-right: 0;}
  .sxnews{margin: 0 15px 40px 0;width: 308px;height: 385px;border: 1px solid #f2f2f2;}
  .sxnews:hover{box-shadow: 0 0 15px #999;}
  .sxnews:hover img{transform: scale(1.1)}
  .sxnews .igs{width: 306px;height: 205px;}
  .sxnews .date,.notice .date{width: 66px;height: 56px;}
  .sxnews .date{z-index: 2;right: 30px;top: 185px;}
  .sxnews .txt{padding: 50px 20px 0;}
  .sxnews .nm{height: 60px;}
  .sxnews .zbtn{padding: 4px 15px;}
</style>



// WEBPACK FOOTER //
// src/components/un_index/ListXnews.vue